export default {
	/**
	 * @route
	 */
	login: 'auth:user:login',
	/**
	 * @route
	 */
	logout: 'auth:user:logout',
	/**
	 * @route
	 */
	'register/approval-needed': 'auth:user:register:approvalNeeded',
	/**
	 * @route
	 */
	register: 'auth:user:register',
	/**
	 * Step 1 of a password reset: present a form to request a token link by email
	 * @route
	 */
	'password-reset': 'auth:user:password:reset',
	/**
	 * Step 2 of a password reset, routed to by that token link, presents a form to set a new password
	 * @route
	 * @param {number|string} user login
	 * @param {string} token Token string
	 */
	'password-reset/:user/:token': 'auth:user:password:change',
	/**
	 * This route contains a session key; if we've come this far, it probably has already been parsed.
	 * We should just redirect to the main app.
	 */
	'session/:key': 'auth:user:sessionKey',
};
